import React from 'react';
import { InboxIcon } from '@heroicons/react/24/outline';

/**
 * Intentional empty state — presentation only.
 */
export default function EmptyState({
    icon: Icon = InboxIcon,
    title,
    description,
    action,
    className = ''
}) {
    return (
        <div className={`empty-state animate-fade-up ${className}`} role="status">
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-brand-50 text-brand-700">
                <Icon className="h-6 w-6" aria-hidden="true" />
            </div>
            <h3 className="text-base font-semibold text-ink-950">{title}</h3>
            {description && (
                <p className="mt-1.5 max-w-sm text-sm text-ink-600 leading-relaxed">{description}</p>
            )}
            {action && <div className="mt-5">{action}</div>}
        </div>
    );
}
